import { useAuthStore } from '@/stores/auth'

// Rotas so' de admin. A API tambem recusa (middleware `admin`); aqui e' so' para
// nao mostrar a tela vazia a quem nao e' admin.
const requireAdmin = (to, from, next) => (useAuthStore().isAdmin ? next() : next({ name: 'apps' }))

const adminRoutes = [
    {
        path: '/admin/homologations',
        name: 'admin-homologations',
        component: () => import('@/views/admin/AdminHomologationQueueView/AdminHomologationQueueView.vue'),
        beforeEnter: requireAdmin,
        meta: {
            title: 'Homologações',
            requiresAuth: true
        }
    },
    {
        path: '/admin/homologations/:requestId',
        name: 'admin-homologation-review',
        component: () => import('@/views/admin/AdminHomologationReviewView/AdminHomologationReviewView.vue'),
        beforeEnter: requireAdmin,
        meta: {
            title: 'Revisão de homologação',
            requiresAuth: true
        }
    }
]

export default adminRoutes
